! function($) {
  'use strict';
  
  var isMobile = navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/webOS/i) || navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPod/i);
  
  if(isMobile) {
    
    /* OPEN SUB MENUS */
    $('#jas-mobile-menu > ul > li').on('click', '.holder', function(e) {
      
      var parentLi = $(this).closest('li');
      var childrenLi = parentLi.children('ul').children('li');

      if (childrenLi.length) {
        $.each( childrenLi, function( i, el ) {
          if ($(el).children('ul').length) {
            $(el).addClass('open');
            $(el).children('ul').slideDown();
          }
		});
      }
    });
    
    /* MAIN MENU LEVEL */
    $('#jas-mobile-menu > ul > li').on('click', '> a', function(e) {

      var parentLi = $(this).closest('li');
      var childrenLi = parentLi.children('ul').children('li');
      var childrenUl = parentLi.children('ul');
      
      if (childrenUl.length) {
        if(parentLi.hasClass('open')) {
          parentLi.removeClass('open');
          parentLi.children('ul').slideUp();

          // close open children
          parentLi.find('li').removeClass('open');
          parentLi.find('ul').slideUp();
        } else {
          parentLi.addClass('open');
          parentLi.children('ul').slideDown();

          //close open siblings li
          parentLi.siblings('li').removeClass('open');
          parentLi.siblings('li').children('ul').slideUp();

          // close open siblings children
          parentLi.siblings('li').find('li').removeClass('open');
          parentLi.siblings('li').find('ul').slideUp();

          // open submenus
          if (childrenLi.length) {
            $.each( childrenLi, function( i, el ) {
              if ($(el).children('ul').length) {
                $(el).addClass('open');
                $(el).children('ul').slideDown();
              }
            });
          }
      	}
      
      	e.preventDefault();
      }
    });
    
    /* SUB MENU LEVEL */
    $('#jas-mobile-menu .sub-menu li').on('click', '> a', function(e) {

      var parentLi = $(this).closest('li');
      var childrenUl = parentLi.children('ul');
      
      if (childrenUl.length) {
        if(parentLi.hasClass('open')) {
          parentLi.removeClass('open');
          parentLi.children('ul').slideUp();
        } else {
          parentLi.addClass('open');
          parentLi.children('ul').slideDown();

          //close open siblings li
          parentLi.siblings('li').removeClass('open');
          parentLi.siblings('li').children('ul').slideUp();
        }
        
        e.preventDefault();
      }
    });
    
    /* OLD MENU FUNCTIONALLITY */
//     $("#jas-mobile-menu ul li").on("click", "> a", function(e) {

//       var parentLi = $(this).closest("li");
      
//       if(parentLi.hasClass("open")) {
//         parentLi.removeClass("open");
//         parentLi.children("ul").slideUp();
        
//         // close open children
//         parentLi.find("li").removeClass("open");
//         parentLi.find("ul").slideUp();
        
//       } else {
//         parentLi.addClass("open");
//         parentLi.children("ul").slideDown();
        
//         //close open siblings li
//         parentLi.siblings("li").removeClass("open");
//         parentLi.siblings("li").children("ul").slideUp();
        
//         // close open siblings children
//         parentLi.siblings("li").find("li").removeClass("open");
//         parentLi.siblings("li").find("ul").slideUp();
//       }
      
//       e.preventDefault();
//     })
  }
  
  $(window).on('scroll', function() {
  	if($('.claue-products-load-more').length) {
      if($(window).scrollTop() + $(window).innerHeight() >= $('.claue-products-load-more').offset().top) {
        $('.claue-products-load-more').not('.disabled').trigger('click');
      }
  	}
  });
  
  $(window).on('load resize', function() {
    if($('.complete_look').is(':visible') && $('.complete_look .product').length) {
       $('.js-custom-scroll-to-look').show(0);
    } else {
      $('.js-custom-scroll-to-look').removeAttr('style');
    };
  })
  
  $('.js-anchor-scroll').on('click', function(e) {
    e.preventDefault();
  	if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
      if (target.length) {
        $('html, body').animate({
          scrollTop: target.offset().top - $('.mp-position-top-fixed').innerHeight() - $('#jas-header').innerHeight()
        }, 700);
        return false;
      }
    }
  })
  
  var $el, $p, $ps, $up, totalHeight;

  $(".sidebar-box .button").click(function() {
    
    totalHeight = 0;
    $el = $(this);
    $p  = $el.parent();
    $up = $p.parent();
    $ps = $up.find(".s2-home");
    
    // measure how tall inside should be by adding together heights of all inside paragraphs (except read-more paragraph)
    $ps.each(function() {
      totalHeight += $(this).outerHeight(true);
    });
    
    console.log($up.height());
    console.log(totalHeight);
    $up
		.css({
      		// Set height to prevent instant jumpdown when max height is removed
      		"height": $up.height(),
      		"max-height": 9999
    	})
    	.animate({
      		"height": totalHeight
    	});
    	// fade out read-more
    $p.fadeOut();

    // prevent jump-down
    return false;
  });
  
}(jQuery);